import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_StaticMembers = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Static Member Functions and Objects"
      videos={[
        "https://www.youtube.com/embed/1QTZeeDL0bc", // Static Data Members & Static Member Functions in C++
        "https://www.youtube.com/embed/N8aGaEk7cJ8", // C++ Static Members (Variable & Function)
      ]}
      takeaways={[
        { text: "Learn all the theory related to this with sample code." },
        { text: "Understand the programming part with practical examples." },
        { text: "Sometimes, questions may ask for differences between static and non-static members." },
      ]}
      questions={[
        "1) Differentiate between static and non-static data members of a class with suitable examples.",
        "2) You are building a book inventory management system for a library. Develop a C++ application to define a class named Book with private data members 'bookID', 'title', and 'author'. Introduce a static variable 'totalBooks' to track the total number of books available. Implement member functions to add new books, update book information, and display book details along with the total number of books.",
      ]}
      exampleVideos={[]} // No example question videos provided
    />
);
}

export default OOP_StaticMembers;
